import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useNewAuthForm } from './NewAuthFormContext';

/**
 *
 * @author: Dumitrana Alinus <alinus@wooter.co>
 * @component: ViewField
 * @date: 24.01.2021
 * @time: 13:53
 */
export function ViewField() {
    const { view } = useNewAuthForm();
    const { setFieldValue } = useFormikContext();

    useEffect(() => setFieldValue('view', view), [view]);

    return null;
}

export default ViewField;
